/**
 * @generated SignedSource<<53bb1c5da8c0ea336d010308982a22c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreAdminScreenUsersItem_Store$data = {
  readonly userCount: number;
  readonly " $fragmentType": "StoreAdminScreenUsersItem_Store";
};
export type StoreAdminScreenUsersItem_Store$key = {
  readonly " $data"?: StoreAdminScreenUsersItem_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreAdminScreenUsersItem_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreAdminScreenUsersItem_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userCount",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "6139426b49b99cb381e09630af44b6f0";

export default node;
